angular.module('picmonicng').directive('factAutosuggestFroala', function () {
  return {
    restrict: 'E',
    require: 'ngModel',
    template:
      '<textarea froala="froalaOptionsText" type="text" ng-model="ngModel" typeahead-wait-ms="100" typeahead="result.name for result in suggestFacts($viewValue)" typeahead-loading="factsLoading" typeahead-on-select="itemSelected($item, $model, $label)" typeahead-focus-first="false" class="{{inputClass ? inputClass:\'form-control fact-name\'}} right-clickable" ng-required="required" ng-disabled="disabled" tabindex="{{tabindex}}" typeahead-append-to="el"></textarea>',
    scope: {
      ngModel: '=',
      factAutosuggestSelect: '=',
      onOpen: '=',
      placeholder: '@',
      inputClass: '@',
      headersOnly: '=',
      noHeaders: '=',
      required: '@',
      disabled: '=ngDisabled',
      tabindex: '=',
      factAutoSuggestResults: '=',
      useFroala: '=',
    },
    link: function (scope, element, attrs) {
      if (attrs.autofocus == 'true') {
        element[0].children[0].focus();
      }

      if (attrs.autoscroll == 'true') {
        element.bind('focus', function () {
          var autosuggest = angular.element('#distractor-autosuggest');
          var scroller = angular.element('.quiz-suggestion-container');
          var top = scroller.scrollTop() - scroller.offset().top + autosuggest.offset().top - 16;
          scroller.animate({ scrollTop: top }, 500);
        });
      }
    },
    controller: [
      '$scope',
      'FactsResource',
      '$timeout',
      '$filter',
      function ($scope, FactsResource, $timeout, $filter) {
        $scope.froalaOptionsText = {
          key: 'LB-22encg1C-8xqA2wzA-13==',
          inlineMode: true,
          buttons: ['italic', 'subscript', 'superscript'],
          editorClass: 'pls-input--froala',
          multiLine: false,
          paragraphy: false,
          placeholder: $scope.placeholder ? $scope.placeholder : 'Add Fact',
          spellcheck: true,
        };
        $scope.suggestFacts = function (val) {
          if (val.length < 3) {
            return;
          }
          $scope.factsLoading = true;
          return FactsResource.query({
            search: val,
            limit: 10,
            headers_only: $scope.headersOnly,
            no_headers: $scope.noHeaders,
          }).$promise.then(function (facts) {
            $timeout(function () {
              $scope.factsLoading = false;
            }, 0);

            var orderedResults = $filter('orderBy')(facts, '+name');

            // pass the results up in into the parent scope if the variable is set
            if ($scope.factAutoSuggestResults) {
              $scope.factAutoSuggestResults.results = orderedResults;
            }

            return orderedResults;
          });
        };

        $scope.itemSelected = function ($item, $model, $label) {
          if (typeof $scope.factAutosuggestSelect == 'function') {
            $scope.factAutosuggestSelect($item, $model, $label);
          }
        };

        if ($scope.onOpen) {
          $scope.$watch(
            function () {
              return $scope.factsLoading;
            },
            function (loading) {
              if (loading === false) {
                $timeout(function () {
                  $scope.onOpen();
                }, 50);
              }
            }
          );
        }
      },
    ],
  };
});
